/* eslint-disable @typescript-eslint/ban-types */
import { TranslationsKey } from 'sofa-reborn-react';

let localeTranslations: { [key: string]: string } | null = null;
let localeApplicationSettings: { [key: string]: string } | null = null;
let localeLocalizationSettings: { [key: string]: string } | null = null;
let localeUrls: { [key: string]: string } | null = null;
let countryCode: string | null = null;
let languageCode: string | null = null;

const localeService = {
	getLocale: (): string => {
		const locale = localeService.getLocaleFromSearch() || localeService.getLocaleFromPath();
		if (locale) {
			languageCode = locale.substring(0, 3);
			countryCode = locale.slice(3);
			return locale;
		}
		return 'en-SE';
	},
	getLocaleFromSearch: () => {
		const params = new URLSearchParams(window.location.search).get('locale');
		const match = params?.match(/(\w{2})(?:[-_])(\w{2})/);
		if (!match) {
			return null;
		}
		return `${match[1].toLowerCase()}-${match[2].toUpperCase()}`;
	},
	getLocaleFromPath: (): string | null => {
		const match = window.location.pathname.match(/\/([a-z]{2})\/([a-z]{2})(?:\/|#|\?)/);
		return match ? match[2] + '-' + match[1].toUpperCase() : null;
	},
	getUrlWithNewLocale: (url: string, locale: string): string => {
		const appUrl = new URL(url);
		appUrl.searchParams.set('locale', locale);
		return appUrl.toString().replace('%2C', ',');
	},
	setTranslations: (
		translations: {},
		appSettings: {},
		localizationSettings: {},
		urls: {}
	): void => {
		localeTranslations = translations;
		localeApplicationSettings = appSettings;
		localeLocalizationSettings = localizationSettings;
		localeUrls = urls;
	},
	getTranslation: (translationKey: TranslationsKey): string => {
		return localeTranslations ? localeTranslations[translationKey] : translationKey;
	},
	getUrl: (urlKey: string): string => {
		return localeUrls ? localeUrls[urlKey] : urlKey;
	},
	getCountryCode: (): string => {
		return countryCode ? countryCode.toLowerCase() : 'se';
	},
	getLanguageCode: (): string => {
		return languageCode ? languageCode.substring(0, 2).toLowerCase() : 'en';
	},
	getApplicationSetting: (flag: string): boolean | string | null => {
		return localeApplicationSettings ? localeApplicationSettings[flag] : null;
	},
	getLocalizationSetting: (setting: string): string | null => {
		return localeLocalizationSettings ? localeLocalizationSettings[setting] : null;
	},
};
export default localeService;
